import {
  BaseContextBuilder,
  Brand,
  PatientContextBuilder,
  ReferralContextBuilder,
  ScopeDataBuilder,
} from '@principle-theorem/principle-core';
import {
  IBrand,
  IPractice,
  IReferral,
  ITemplateContextOption,
  ITemplatesWithContext,
  resolvedContextOption,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import {
  query$,
  undeletedQuery,
  where,
  WithRef,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export function buildReferralTemplatesWithContext(
  referral: WithRef<IReferral>,
  practice: WithRef<IPractice>,
  appUrl: string,
  brand$: Observable<WithRef<IBrand>>
): Observable<ITemplatesWithContext> {
  const scopes = [
    TemplateScope.None,
    TemplateScope.Patient,
    TemplateScope.Referral,
  ];

  return brand$.pipe(
    switchMap((brand) =>
      query$(
        undeletedQuery(Brand.templateCol(brand)),
        where('scope', 'in', scopes),
        where('ownerScope', '==', brand.ref)
      ).pipe(
        map((templates) => ({
          templates,
          brand,
        }))
      )
    ),
    switchMap(async ({ templates }) => {
      const referralScopeData = await ScopeDataBuilder.buildReferralScopeData(
        referral,
        practice,
        appUrl
      );

      const contextOptions: ITemplateContextOption[] = [
        resolvedContextOption('', TemplateScope.None, {
          context: new BaseContextBuilder().build(),
          scopeData: {},
        }),
        resolvedContextOption(referral.patient.ref.id, TemplateScope.Patient, {
          context: new PatientContextBuilder(referralScopeData).build(),
          scopeData: referralScopeData,
        }),
        resolvedContextOption(referral.ref.id, TemplateScope.Referral, {
          context: new ReferralContextBuilder(referralScopeData).build(),
          scopeData: referralScopeData,
        }),
      ];

      return { templates, contextOptions } satisfies ITemplatesWithContext;
    })
  );
}
